import { MarketplaceOrderApiModel } from '~/lib/api/smartsend/types';

export function FilterToSendableItems(x: MarketplaceOrderApiModel): boolean {
  return x.Source.Id !== 'grouped';
}
